import React from "react";
import {
  Box,
  Heading,
  useTheme,
  Text,
  Input,
  Button,
  Flex,
} from "@chakra-ui/react";
import { Theme } from "../../theme";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import getAxios from "../../hooks/useAxios";
import { AxiosError } from "axios";

const Login = () => {
  const axios = getAxios();
  const theme = useTheme<Theme>();
  const navigate = useNavigate();
  const [inputPhone, setInputPhone] = React.useState("");
  const [unRegisteredNumber, setUnRegisteredNumber] =
    React.useState<boolean>(false);
  const [invalidNumber, setInvalidNumber] = React.useState<boolean>(false);
  const [loginPhone, setLoginPhone] = React.useState<string>();
  const [isLoginLoading, setIsLoginLoading] = React.useState(false);

  const handleInputChange = (val: string) => {
    setInputPhone(val);
    setLoginPhone(val);
  };

  const handleLoginApiCall = async (e: React.BaseSyntheticEvent) => {
    e.preventDefault();
    setIsLoginLoading(true);
    if (inputPhone === "" || loginPhone === "") {
      setInvalidNumber(true);
      setIsLoginLoading(false);
      return;
    }
    try {
      const resOtp = await axios.get(`/otp/${loginPhone}`);
      setIsLoginLoading(false);
      navigate({
        pathname: "/otp",
        search: `?success=${true}&phone=${loginPhone}`,
      });
    } catch (error) {
      const err = error as AxiosError;
      if (err?.response?.status === 400) {
        setInvalidNumber(true);
        setUnRegisteredNumber(false);
        setIsLoginLoading(false);
      } else if (err?.response?.status === 404) {
        setUnRegisteredNumber(true);
        setInvalidNumber(false);
        setIsLoginLoading(false);
      } else {
        console.log("error in otp generation", error);
        setIsLoginLoading(false);
      }
    }
  };

  return (
    <Box sx={{ marginTop: "16.5vh", maxWidth: "24rem" }}>
      <form onSubmit={handleLoginApiCall}>
        <Heading sx={{ marginBottom: theme.space.sm }}>
          Access your dashboard
        </Heading>
        <Text
          sx={{
            fontSize: theme.fontSizes.subHeading2,
            marginBottom: theme.space["3xl"],
          }}
        >
          Sign in to your Zippy Account
        </Text>
        <Text
          color={theme.colors.secondary.light}
          sx={{ fontSize: theme.fontSizes.label, marginBottom: theme.space.xs }}
        >
          Phone Number
        </Text>
        <Input
          type="tel"
          value={inputPhone}
          onChange={(e) => handleInputChange(e.target.value)}
          name="phone"
          placeholder="Your number"
          variant={"outline"}
        />

        <Box sx={{ minHeight: "1rem" }}>
          {invalidNumber && (
            <Text variant={"label"} color={theme.colors.error}>
              Invalid number!
            </Text>
          )}
          {unRegisteredNumber && (
            <Text variant={"label"} color={theme.colors.error}>
              Unregistered number!
            </Text>
          )}
        </Box>

        <Flex sx={{ flexDirection: "column" }}>
          <Box sx={{ marginTop: theme.space.xxl }}>
            <Button
              type="submit"
              width="100%"
              height="3rem"
              rightIcon={<FaArrowRight />}
              isLoading={isLoginLoading ? true : false}
              style={{
                background: theme.colors.primary.main,
                color: theme.colors.bg.main,
              }}
            >
              <Text sx={{ fontSize: theme.fontSizes.body }}>Next</Text>
            </Button>
          </Box>
        </Flex>
      </form>
    </Box>
  );
};

export default Login;
